import React from 'react'
import { Result, Button } from 'antd'

import { Link } from 'react-router-dom'

const error = (props) => (
  <Result
    status='error'
    title='Something went wrong'
    subTitle='There are some problems with your operation.'
    extra={
      <Link to='/'>
        <Button type='primary'>Back Home</Button>
      </Link>
    }
  />
)

export default error
